import { CdkDrag, CdkDragDrop, CdkDragHandle, CdkDropList, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, Inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faGripLinesVertical } from '@fortawesome/free-solid-svg-icons';
import { SortDialogData } from './models/sort-dialog-data';
import { SortDialogResult } from './models/sort-dialog-result';

import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-sort-dialog',
    templateUrl: './sort-dialog.component.html',
    styleUrls: ['./sort-dialog.component.scss'],
    imports: [MatCardModule, CdkDropList, CdkDrag, FaIconComponent, CdkDragHandle, MatButtonModule]
})
export class SortDialogComponent {
    public faGripLinesVertical = faGripLinesVertical;

    constructor(
        public dialogRef: MatDialogRef<SortDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public datas: SortDialogData
    ) {}

    onConfirm(): void {
        var result = new SortDialogResult(false, this.datas.items);
        this.dialogRef.close(result);
    }

    onDismiss(): void {
        var result = new SortDialogResult(true);
        this.dialogRef.close(result);
    }

    drop(event: CdkDragDrop<string[]>) {
        moveItemInArray(this.datas.items, event.previousIndex, event.currentIndex);
        let index = 1;
        this.datas.items.forEach((x) => (x.order = index++));
    }
}
